import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      WEEK: "Uke",
      SHORT_DATE_FORMAT: "EEE d. MMM",
      CANCELLED: "Avbestilt",
      CLOSED: "Stengt",
      DELIVERED: "Levert",
      IN_TRANSIT: "Underveis",
      LONG_DATE_FORMAT: "d. MMM HH:mm",
      MAKE_CHANGES_BY: "Endre innen",
    },
    se: {
      WEEK: "Vecka",
      SHORT_DATE_FORMAT: "EEE d MMM",
      CANCELLED: "Avbokad",
      CLOSED: "Stängt",
      DELIVERED: "Levererad",
      IN_TRANSIT: "På väg",
      LONG_DATE_FORMAT: "d MMM HH:mm",
      MAKE_CHANGES_BY: "Ändra senast",
    },
    dk: {
      WEEK: "Uge",
      SHORT_DATE_FORMAT: "EEE d. MMM",
      CANCELLED: "Afbestilt",
      CLOSED: "Lukket",
      DELIVERED: "Leveret",
      IN_TRANSIT: "Undervejs",
      LONG_DATE_FORMAT: "d. MMM HH:mm",
      MAKE_CHANGES_BY: "Ændr senest",
    },
  } as const
)[language];
